<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard3.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">ESTAMOS PARA AYUDARTE</b-button>
            </div>
          </b-col>
          <b-col col md="9" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5">Solicita el enganche y mensualidad que deseas</h1>
              <b-row class="justify-content-md-center">
                <b-col col md="5" class="card-body text-center">
                    <h2 style="font-size: 20px">Escoge tu enganche</h2>
                    <b-row class="justify-content-md-center">
                    <p style="font-size: 12px">¿Cuánto sería tu primer pago?</p>
                    <h3>$ {{formatPrice(minValue)}}</h3>
                        <b-input-group class="mt-4">
                          <b-form-input style="border:0px;" v-model="minValue" type="range" :min="cotizar15()" :max="cotizar90()" step="1"></b-form-input>
                        </b-input-group> 
                      <!-- <div>parametros: {{minValue}}</div> -->
                    </b-row>
                </b-col>
                <b-col col md="5" class="card-body text-center">
                  <h2 style="font-size: 20px;">Ahora tu mensualidad</h2>
                  <p style="font-size: 12px">Escoge lo más adecuado para ti</p>
                    <b-row cols="2" class="text-left">
                      <b-col><b-form-radio v-model="selected" name="some-radios" value="12"> <p style="font-size: 13px;">12 Meses ${{this.calcular()}}</p></b-form-radio></b-col>
                      <b-col><b-form-radio v-model="selected" name="some-radios" value="24"><p style="font-size: 13px">24 Meses ${{this.calcular2()}}</p></b-form-radio></b-col>
                      <b-col><b-form-radio v-model="selected" name="some-radios" value="36"><p style="font-size: 13px">36 Meses ${{this.calcular3()}}</p></b-form-radio></b-col>
                      <b-col><b-form-radio v-model="selected" name="some-radios" value="48"><p style="font-size: 13px">48 Meses ${{this.calcular4()}}</p></b-form-radio></b-col>
                    </b-row>
                </b-col>
              </b-row>
              <p style="font-size: 20px">Es el momento de personalizar tu solicitud de Crédito</p>
              <h1 style="font-size: 20px">Ten a la mano los siguientes documentos:</h1>
                <b-row class="justify-content-md-center">
                  <b-col col md="10" class="text-left mt-4">
                    <p class="mb-4" style="font-size: 12px">Para el envío de esta información un asesor "Autocom" se pondrá en comunicación contigo para 
                      darte el seguimiento adecuado. Espera esta ayuda en las próximas horas. La comunicación y envío de 
                      documentos será por correo electrónico o por whatsapp.</p>
                      <hr>
                        <b-row>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Escoge tu enganche</h2>
                            <p style="font-size: 12px">(INE, IFE, Pasaporte o Cédula Profesional).</p>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- CURP</h2>
                            <p style="font-size: 12px">(Qué se vean los 18 dígitos).</p>
                          </b-col>
                          <div class="w-100"></div>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Comprobante de Domicilio</h2>
                            <p style="font-size: 12px">(Que aparezca el domicilio completo; Este puede ser de CFE, Agua o Teléfono).</p>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Licencia de Conducir</h2>
                            <p style="font-size: 12px">(Vigente).</p>
                          </b-col>
                          <div class="w-100"></div>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Comprobamte de Ingresos</h2>
                            <p style="font-size: 12px">(3 últimos recibos de nómina y 3 estasos de cuenta bancarios caratula y reflejo de depósitos).</p>
                          </b-col>
                          <!-- <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Formato garantía</h2>
                          </b-col>
                          <div class="w-100"></div>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Carta Beneficios</h2>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Carta de conformidad</h2>
                          </b-col> -->
                        </b-row>
                      <hr>
                        <b-row>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Persona Física con actividad empresarial</h2>
                            <p style="font-size: 12px">PFAE (Declaración anual de ISR, constancia de situación fiscal con cédula de indentificación 
                              fiscal incluida).</p>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Extranjeros</h2>
                            <p style="font-size: 12px">(Formato migratorio: FM2-FM3).</p>
                          </b-col>
                        </b-row>
                          <b-row class="justify-content-md-center">
                             <b-col cols="12" md="auto">
                                           <b-button @click.prevent="reserva()" variant="primary" class="button_H">SOLICITAR AHORA</b-button>
                                           <b-button @click.prevent="regresar()" variant="primary" class="button_H1">REGRESAR</b-button>
                             </b-col>
                           </b-row>
                  </b-col>
                </b-row>
          </b-col>
    </b-row>
</b-container>
</template>

<script>
import Sesion from './Sesion.vue';
import Descripcion from './Descripcion.vue';

export default {
  name: 'Autocom',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {
      contents: null,
      autos: [],
      photos: [],
      vin: sessionStorage.getItem("vinUnidad"),
      type: sessionStorage.getItem("type"),
      paso:'',
      calculo:'',
      calculo2:'',
      calculo3:'',
      calculo4:'',
      calculo5:'',
      porcentaje: '',
      selected: sessionStorage.getItem("plazo"),
      minValue: sessionStorage.getItem("enganche"),
      precio1: '',
      show: true,

      };
  },

  methods: {

    tokenStock(){
      let user = {
      username: "desarrolloti@autocom.mx",
      password: "Autocom2021"};

      //axios.post("https://pruebas.autocomcube.mx/api/token/login", user)
      axios.post("https://autocomcube.mx/api/token/login", user) //PRO
      .then((response) => {
        this.contents = response.data.token;
              if(this.contents != null){
                 sessionStorage.setItem("tokenStock", response.data.token);   
                 this.cargarInfoVehiculo();             
              }
        }).catch(error => {
          console.log(error);
        });
    },

    toke(){
       let userTk = {
       username: "payments@autocom.mx",
       //password: "B8jc8q!n"}; //qa
       password: "d#7X4jem"}; //prod
       axios.post("https://financiamiento.autocomcube.mx/api/token/login", userTk)
        .then((response) => {
          this.contents = response.data.token;
          //console.log('Token es Financiamiento--->', response.data.token)
          sessionStorage.setItem("tknFin", response.data.token);
        });
    },
    datos(){

      if( this.selected == null && this.minValue == null ){
        this.selected = 12;
        this.minValue = sessionStorage.getItem("precio") * 0.25;;
      } else {
        this.selected = sessionStorage.getItem("plazo");
        this.minValue = sessionStorage.getItem("enganche");
      }
      console.log('Select -->',this.selected);
      console.log('Min Value -->',this.minValue);
    },

    reserva(){
            this.$router.push({ path: '/Reserva'});
    },


    cargarInfoVehiculo(){

      if( this.$route.query.type == 'U'){
          //  console.log('Seminuevo');
              //axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
              axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin,},
            })
            .then((response) => {
                  this.precio1 = response.data.usedstock[0].webPrice;
                  sessionStorage.setItem("precio", this.precio1);
                  if(this.precio1 != 'undefined'){
                      this.show = false;
                  }
            }).catch(error => {
          console.log(error);
        });
       } else if( this.$route.query.type == 'N'){
              //axios.get("https://pruebas.autocomcube.mx/ab/api/newstock", { //QA
              axios.get("https://autocomcube.mx/ab/api/newstock", { //PRO        
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin,},
            })
            .then((response) => {
                  this.precio1 = response.data.newstock[0].webPrice;
                  sessionStorage.setItem("precio", this.precio1);
                  if(this.precio1 != 'undefined'){
                      this.show = false;
                  }
            }).catch(error => {
          console.log(error);
        });
      }
    },

    bienvenida(){
      this.$router.push({ path: '/Bienvenida'});
    },
    
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    cotizar15() {
      return  this.precio1 * 0.15;
    },

    cotizar90() {
      return this.precio1 * 0.90;
    },

     valor() {
      this.val = +(((this.minValue)*100)/this.precio1).toFixed(2);
      return this.val;
    },

    valor2(){
      if( this.valor() >= 15 && this.valor() <= 19.99 ){
          this.taza = 22.90;
      } else if( this.valor() >= 20 && this.valor() <= 29.99 ){
          this.taza = 21.90;
      }  else if( this.valor() >= 30 && this.valor() <= 39.99 ){
          this.taza = 19.90;
      } else if( this.valor() >= 40 && this.valor() <= 49.99 ){
          this.taza = 18.90;
      } else if( this.valor() >= 50 && this.valor() <= 90 ){
          this.taza = 17.90;
      }
      return this.taza;
    },

    
     valor3(){
      if( this.selected == 12){
        this.paso = this.calculo;
      } else if( this.selected == 24){
        this.paso = this.calculo2;
      } else if( this.selected == 36){
        this.paso = this.calculo3;
      } else if( this.selected == 48){
        this.paso = this.calculo4;
      } else if( this.selected == 60){
        this.paso = this.calculo5;
      }
      return this.paso;
    },

    montof(){
      this.montf = this.precio1-this.minValue;
      return this.montf;
    },

          calcular() {
                this.formData={
                enganche:this.valor(),
                plazo:12,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod        
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"), 'Content-Type': 'application/json'}
      }).then((response) => { this.calculo = response.data.mensualidad;
        //console.log('Porcentaje-->',this.valor())
        //console.log('taza-->', this.valor2())
        //console.log('Costo-->', this.costo)
      });
      return this.formatPrice(this.calculo)
     },

      calcular2() {
                this.formData={
                enganche:this.valor(),
                plazo:24,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod        
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"),
                  'Content-Type': 'application/json'}
      }).then((response) => {
        this.calculo2 = response.data.mensualidad;
        //console.log('respuesta-->',this.calculo2)
      });
      return this.formatPrice(this.calculo2)
     },

      calcular3() {
                this.formData={
                enganche:this.valor(),
                plazo:36,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod        
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"),
                  'Content-Type': 'application/json'}
      }).then((response) => {
        this.calculo3 = response.data.mensualidad;
        //console.log('respuesta-->',this.calculo3)
      });
      return this.formatPrice(this.calculo3)
     },

      calcular4() {
                this.formData={
                enganche:this.valor(),
                plazo:48,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod        
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"),
                  'Content-Type': 'application/json'}
      }).then((response) => {
        this.calculo4 = response.data.mensualidad;
        //console.log('respuesta-->',this.calculo4)
      });
      return this.formatPrice(this.calculo4)
     },

      regresar(){
        this.$router.push({ path: '/Bienvenida'});          
      },

      info(){
          console.log('Engtrando a datos Financiamiento --> ',this.vin +' '+this.type);
          if( this.vin == 'undefined' && this.type == 'undefined'){
            sessionStorage.setItem("vin", this.$route.query.vin);
            sessionStorage.setItem("vinUnidad", this.$route.query.vin);
            sessionStorage.setItem("type", this.$route.query.type);
                      location.reload();
          } else if( this.vin == null && this.type == null){
            sessionStorage.setItem("vinUnidad", this.$route.query.vin);
            sessionStorage.setItem("vin", this.$route.query.vin);
            sessionStorage.setItem("type", this.$route.query.type);
                      location.reload();
          }

      }

  },
  
  created() {
    this.info();
    this.toke();
    this.tokenStock();
    this.datos();
  }
}
</script>

<style scoped>


</style>